import { useTranslation } from 'react-i18next';
import { useUserStore } from '@shared/stores';
import { Typography } from '@ui/components';

export const DashboardHeader = () => {
  const { user } = useUserStore();
  const { t } = useTranslation();

  return (
    <Typography className="mb-6" variant="h600" element="h1">
      {t('DASHBOARD.HEADER_TITLE', { name: user?.firstName })}
    </Typography>
  );
};
